import moment from "moment";

Vue.filter('date', function (value) {
    return moment(value).format("DD/MM/Y")
})
